export const devServerPort = (stage: string, override?: string) => {
  if (override !== undefined) {
    const port = Number(override)
    if (!Number.isInteger(port) || port < 1024 || port > 65_535) {
      throw new Error(`PORT must be an integer between 1024 and 65535, received: ${override}`)
    }
    return port
  }
  const pr = /^pr-(\d+)$/.exec(stage)
  return pr ? 4000 + (Number(pr[1]) % 1000) : 3000
}

export const devServerUrl = (stage: string, override?: string) => `http://localhost:${devServerPort(stage, override)}`
